export default "__VITE_ASSET__9334bf26__"